'use client';

import { FC, PropsWithChildren } from 'react';
import { Portal, Modal } from 'components/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';
import { useUserConsentModal } from './user-consent-modal-context';
import { useUserConsentLoader } from './user-consent-loader-context';

export const UserConsentModalWrapper: FC<PropsWithChildren> = ({
  children
}) => {
  const userConsentModal = useUserConsentModal();
  const userConsentLoader = useUserConsentLoader();

  return (
    <Portal id={ROOT_PORTALS}>
      <Modal
        {...userConsentModal?.modalProps}
        disableBackdropClick={
          userConsentLoader?.isUserConsentLoading ||
          userConsentModal?.modalProps?.disableBackdropClick
        }
        dismissible={
          !userConsentLoader?.isUserConsentLoading ||
          userConsentModal?.modalProps?.dismissible
        }
      >
        {children}
      </Modal>
    </Portal>
  );
};
